
export function isMobile() {
    return window.innerWidth < 991;
}

export function isMobileSafari() {
    // For desktop we get device and device type as undefined.
    return !!(ua && ua.device && ua.device.type && ua.browser && ua.browser.name
        && (ua.device.type.toLowerCase() === 'mobile' && ua.browser.name.toLowerCase().includes("safari")));
}

export function getOS() {
    let userAgent = window.navigator.userAgent,
        platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown',
        macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
        windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
        iosPlatforms = ['iPhone', 'iPad', 'iPod'],
        os = null;

    if (macosPlatforms.indexOf(platform) !== -1) {
        os = 'Mac OS';
    } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = 'iOS';
    } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = 'Windows';
    } else if (/Android/.test(userAgent)) {
        os = 'Android';
    } else if (/Linux/.test(platform)) {
        os = 'Linux';
    }

    return os;
}

export function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min) + min);
}

export function splitName(fullName) {
    const [firstName, ...lastName] = fullName.split(' ').filter(Boolean);
    return {
        firstName: firstName,
        lastName: lastName.join(' ')
    }
}


export function parseJwt(token) {
    try {
        let base64Url = token.split('.')[1];
        let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } catch (e) {
        return {};
    }
}
